"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _dateFns = require("date-fns");
var _reactKeyedFileBrowser = _interopRequireDefault(require("react-keyed-file-browser"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class RcFileBrowser extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: props.files,
      directoryTree: props.directoryTree,
      readOnly: props.readOnly
    };
  }
  convertFiles(files, children) {
    for (let i = 0; i < children.length; i += 1) {
      const child = children[i];
      if (child.directory) {
        this.convertFiles(files, child.children);
      } else {
        const file = {
          key: child.path,
          modified: +(0, _dateFns.parseJSON)(child.lastModified),
          size: child.size
        };
        files.push(file);
      }
    }
  }
  render() {
    const {
      files
    } = this.state;
    const {
      directoryTree
    } = this.state;
    let filesToDisplay = files;
    if (directoryTree) {
      filesToDisplay = [];
      this.convertFiles(filesToDisplay, directoryTree.children);
    }
    return /*#__PURE__*/_react.default.createElement(_reactKeyedFileBrowser.default, {
      files: filesToDisplay,
      showFoldersOnFilter: true,
      detailRenderer: () => null,
      onDownloadFile: this.props.onDownloadFile,
      icons: {
        File: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }, "text_snippet"),
        Image: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }, "photo"),
        PDF: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }, "picture_as_pdf"),
        Rename: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }),
        Folder: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }, "folder"),
        FolderOpen: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }, "folder_open"),
        Delete: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }),
        Loading: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }),
        Download: /*#__PURE__*/_react.default.createElement("i", {
          className: "material-icons",
          "aria-hidden": "true"
        }, "cloud_download")
      }
    });
  }
}
exports.default = RcFileBrowser;
RcFileBrowser.propTypes = {
  files: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    modified: _propTypes.default.number,
    size: _propTypes.default.number
  })).isRequired,
  directoryTree: _propTypes.default.object,
  onDownloadFile: _propTypes.default.func,
  readOnly: _propTypes.default.bool
};
RcFileBrowser.defaultProps = {
  files: [],
  readOnly: true,
  onDownloadFile: null
};
//# sourceMappingURL=RcFileBrowser.js.map